export default __webpack_public_path__ + "static/media/1.80301c53.svg";